import {Spin} from "antd"
import React, {useEffect, useState} from "react"
import {calendarService} from "services"
import {CreateEvent, ListEvents} from "./parts"
import styles from "./StudentInfoCalendarPanel.module.css"
import {Auth} from "types/auth"

type DisplayPart = "list" | "create"

type Props = {
    displayPart?: DisplayPart
    departmentId?: number
    student?: Auth.DepartmentStudent
    onClose?: () => void
}

export const StudentInfoCalendarPanel = (props: Props) => {
    const {onClose, displayPart = "list", student} = props
    const [displayMode, setDisplayMode] = useState<DisplayPart>(displayPart)

    const [calendarId, setCalendarId] = useState(null)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const {data} = await calendarService.getMyPrimaryCalendar({}, {})
        const {calendar_id} = data
        setCalendarId(calendar_id)
    }

    const onNavigate = (_displayMode: DisplayPart) => {
        setDisplayMode(_displayMode)
    }

    if (!calendarId) {
        return (
            <div className={styles.loading}>
                <Spin />
            </div>
        )
    }

    return (
        <>
            {displayMode === "list" ? (
                <ListEvents onNavigate={onNavigate} onClose={onClose} departmentId={props.departmentId} />
            ) : (
                <CreateEvent calendarId={calendarId} student={student} onNavigate={onNavigate} />
            )}
        </>
    )
}
